import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import Switch from '@/components/FormElements/Switch';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { selectActiveProfileSettingsAugmented } from '@/store/user/selectors/selectActiveProfileSettingsAugmented';
import { updateProfileSetting } from '@/store/user/thunks/updateProfileSetting';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// This is what we have in settings:
//   "community": {
//     anyone-can-create-tags: false
//     anyone-can-raise: false
//   }

export function CommunityPostSettings() {
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();
  const profile = useSelector(state =>
    selectActiveProfileAugmented(state, { activeProfileId })
  );
  const settings = useSelector(state =>
    selectActiveProfileSettingsAugmented(state, { activeProfileId })
  );

  const [anyoneCanRaisePost, setAnyoneCanRaisePost] = useState(
    settings.community?.anyoneCanRaise ?? false
  );
  const [anyoneCanCreateTags, setAnyoneCanCreateTags] = useState(
    settings.community?.anyoneCanCreateTags ?? false
  );

  const [token] = useTokenState();

  if (!profile.isCommunity) {
    return null;
  }

  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Настройки постов</h4>
          <p>
            Выберите, могут ли участники сообщества поднимать посты и добавлять
            теги
          </p>
        </SettingSectionTitle>
        <Settings>
          <Switch
            label="участники могут создавать теги"
            checked={anyoneCanCreateTags}
            onClick={e => {
              const anyoneCan = e.target.checked;
              setAnyoneCanCreateTags(anyoneCan);
              dispatch(
                updateProfileSetting(
                  `community.anyoneCanCreateTags`,
                  anyoneCan,
                  token
                )
              );
            }}
          />
          <Switch
            label="участники могут поднимать посты"
            checked={anyoneCanRaisePost}
            onClick={e => {
              const anyoneCan = e.target.checked;
              setAnyoneCanRaisePost(anyoneCan);
              dispatch(
                updateProfileSetting(
                  `community.anyoneCanRaise`,
                  anyoneCan,
                  token
                )
              );
            }}
          />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}
